import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux-stores/store';

const withAuth = (WrappedComponent: React.FC) : React.FC => {
    return (props: any) => {
        const { isAuthenticated } = useSelector((state: RootState) => state.auth);
        const auth = useSelector((state: RootState) => state.auth);

        if (!isAuthenticated) {
            // return <Navigate to="/login" replace />;
        }

        return <WrappedComponent {...props} />;
    };
};

export default withAuth;